// In your reducer (e.g., queryReducer.js)

import * as types from "../actions/types";

const initialState = {
  querydetail: {},
  comments: [],
};

const addQueryCommentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_QUERY_DETAIL_LIST:
      return {
        ...state,
        querydetail: action.payload.data,
      };
    case types.ADD_QUERY_COMMENT:
      return {
        ...state,
        comments: [...state.comments, action.payload],
      };
    // Other cases...
    default:
      return state;
  }
};

export default addQueryCommentReducer;
